import { useEffect } from "react";
import { SearchEverywhereModal } from "./SearchEverywhereModal";
import { useSearchEverywhere } from "./context";

export const SEARCH_EVERYWHERE_KBD_SHORTCUT = "Ctrl+Shift+F";

export function SearchEverywhere() {
  const { open, setOpen } = useSearchEverywhere();

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "f") {
        e.preventDefault();
        setOpen(!open);
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, setOpen]);

  return <SearchEverywhereModal open={open} onOpenChange={setOpen} />;
}
